import carIcon from "../../assets/iconos/car.png"
// import { TIPO_USUARIO_WEB } from "../../utils/const/int-const";

export const MODULOS_ADMINISTRACION = [
    {
        id: 0,
        titulo: 'Gestionar Empresas',
        descripcion: 'Datos Empresas',
        icono: carIcon,
        color: 'rgba(0, 128, 0, 0.5)',
        href: 'administracion/gestionar-empresa/listar-empresas',
        // tipoUsuario: TIPO_USUARIO_WEB.REGULAR,
    },
];